"use client";

import { FEATURE_FLAGS } from "@cede/types";
import { ClaimRewards } from "../Reward/ClaimRewards";
import { Button } from "@/components/ui/button";
import { useFeatureFlagIsOn } from "@/hooks/feature-flags";
import { cn } from "@/lib/utils";
import { Gift } from "lucide-react";

interface ClaimButtonsProps {
  className?: string;
}

// Mock data - to be replaced with real data later
const MOCK_DAILY_PROGRESS = 2; // Day 2 out of 7

export const ClaimButtons = ({ className }: ClaimButtonsProps) => {
  const isDailyLoginEnabled = useFeatureFlagIsOn(FEATURE_FLAGS.QUESTS_HUB_DAILY_LOGIN);

  const handleDailyLogin = () => {
    // TODO: Implement daily login functionality
  };

  return (
    <div className={cn("flex flex-col gap-4", className)}>
      {/* Claim Reward Button */}
      <div className="w-full">
        <ClaimRewards fullWidth />
      </div>

      {/* Daily Login Rewards Card */}
      {isDailyLoginEnabled && (
        <div className="bg-cede-bg-component border-container rounded-lg">
          <div className="p-4">
            <div className="flex items-center justify-between mb-4">
              <h3 className="body1 text-cede-text-primary !font-bold">Daily Login Rewards</h3>
              <Button
                onClick={handleDailyLogin}
                variant="primary"
                size="small"
                className="bg-cede-text-primary text-cede-bg-primary hover:bg-cede-text-secondary transition-colors"
              >
                <Gift className="w-4 h-4" />
                Receive
              </Button>
            </div>

            {/* Progress Bar */}
            <div className="flex gap-1">
              {Array.from({ length: 7 }, (_, index) => {
                const dayIndex = index + 1;
                const isCompleted = dayIndex < MOCK_DAILY_PROGRESS;
                const isCurrent = dayIndex === MOCK_DAILY_PROGRESS;
                const isFuture = dayIndex > MOCK_DAILY_PROGRESS;

                return (
                  <div
                    key={index}
                    className={cn("flex-1 h-2 rounded-full relative", {
                      "bg-cede-primary": isCompleted,
                      "bg-cede-primary-light shadow-lg shadow-cede-primary/50 animate-pulse": isCurrent,
                      "bg-cede-border opacity-50": isFuture,
                    })}
                  >
                    {isCurrent && (
                      <div className="absolute inset-0 w-full h-2 bg-cede-primary-light rounded-full animate-ping opacity-30" />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
